import { colors } from '../../colors';
var jumplink = {
  bgColor: colors.eggShell,
  borderColor: colors.overcast,
  linkColor: colors.brickOrange
};
export default jumplink;